/* The Tab component displays the name of the tab (label property) and adds an additional class if the tab is active. 
* When clicked, the compoent will fire a handler that will let 'Tabs' component know which tab should be active
* In the return statement below, added "role='presentation" for accessiblity which tells screen readers that the elements need to be in the DOM 
* but the semantics of them are inaccurate, so ignore. 
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tab extends Component {
    static propTypes = {
        activeTab: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    onClick = () => {
        const { label, onClick } = this.props;
        onClick(label);
    }

    render() {
        const { onClick, props: {
                    activeTab,
                    label,
                    },
                } = this;
        let className = 'tab-list-item';

        if (activeTab === label) {
            className += ' tab-list-active';
        }
        return(
            <li className={className} onClick={onClick} onKeyDown={onClick} role='presentation'>{label}</li>
        );
    }
}

export default Tab